<form class="home-cuenta__form home-cuenta-natural" [formGroup]="form" novalidate>
  <div class="home-cuenta__row">
    <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalid('primerNombre')">
      <label class="home-cuenta__label" [for]="idPrefix + '-primer-nombre'">Primer nombre*</label>
      <input [id]="idPrefix + '-primer-nombre'" class="home-cuenta__input"
        [class.is-invalid]="isInvalid('primerNombre')" type="text" formControlName="primerNombre"
        placeholder="Escribe aquí" maxlength="20" autocomplete="given-name" appOnlyLetters />
      @if (isInvalid('primerNombre')) {
      <div class="home-cuenta__error">{{ errorMsg('primerNombre') }}</div>
      }
    </div>
    <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalid('segundoNombre')">
      <label class="home-cuenta__label" [for]="idPrefix + '-segundo-nombre'">Segundo nombre</label>
      <input [id]="idPrefix + '-segundo-nombre'" class="home-cuenta__input"
        [class.is-invalid]="isInvalid('segundoNombre')" type="text" formControlName="segundoNombre"
        placeholder="Escribe aquí" maxlength="20" autocomplete="additional-name" appOnlyLetters />
      @if (isInvalid('segundoNombre')) {
      <div class="home-cuenta__error">{{ errorMsg('segundoNombre') }}</div>
      }
    </div>
  </div>

  <div class="home-cuenta__row">
    <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalid('primerApellido')">
      <label class="home-cuenta__label" [for]="idPrefix + '-primer-apellido'">Primer Apellido*</label>
      <input [id]="idPrefix + '-primer-apellido'" class="home-cuenta__input"
        [class.is-invalid]="isInvalid('primerApellido')" type="text" formControlName="primerApellido"
        placeholder="Escribe aquí" maxlength="20" autocomplete="family-name" appOnlyLetters />
      @if (isInvalid('primerApellido')) {
      <div class="home-cuenta__error">{{ errorMsg('primerApellido') }}</div>
      }
    </div>
    <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalid('segundoApellido')">
      <label class="home-cuenta__label" [for]="idPrefix + '-segundo-apellido'">Segundo Apellido</label>
      <input [id]="idPrefix + '-segundo-apellido'" class="home-cuenta__input"
        [class.is-invalid]="isInvalid('segundoApellido')" type="text" formControlName="segundoApellido"
        placeholder="Escribe aquí" maxlength="20" appOnlyLetters />
      @if (isInvalid('segundoApellido')) {
      <div class="home-cuenta__error">{{ errorMsg('segundoApellido') }}</div>
      }
    </div>
  </div>

  <div class="home-cuenta__row home-cuenta__row--triple home-cuenta__row--stack-mobile">
    <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalid('celular')">
      <label class="home-cuenta__label" [for]="idPrefix + '-celular'">Celular*</label>
      <input [id]="idPrefix + '-celular'" class="home-cuenta__input" [class.is-invalid]="isInvalid('celular')"
        type="tel" formControlName="celular" placeholder="Escribe aquí" maxlength="10" autocomplete="tel"
        appOnlyNumbers />
      @if (isInvalid('celular')) {
      <div class="home-cuenta__error">{{ errorMsg('celular') }}</div>
      }
    </div>
    <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalid('tieneRUT')">
      <span class="home-cuenta__label">¿Tiene RUT?*</span>
      <div class="home-cuenta__radios" [class.home-cuenta__radios--invalid]="isInvalid('tieneRUT')">
        <label class="home-cuenta__radio" [for]="idPrefix + '-tiene-rut-si'">
          <input [id]="idPrefix + '-tiene-rut-si'" type="radio" formControlName="tieneRUT" value="SI" />
          <span>Sí</span>
        </label>
        <label class="home-cuenta__radio" [for]="idPrefix + '-tiene-rut-no'">
          <input [id]="idPrefix + '-tiene-rut-no'" type="radio" formControlName="tieneRUT" value="NO" />
          <span>No</span>
        </label>
      </div>
      @if (isInvalid('tieneRUT')) {
      <div class="home-cuenta__error">{{ errorMsg('tieneRUT') }}</div>
      }
    </div>
    <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalid('correo')">
      <label class="home-cuenta__label" [for]="idPrefix + '-correo'">Correo electrónico*</label>
      <input [id]="idPrefix + '-correo'" class="home-cuenta__input" [class.is-invalid]="isInvalid('correo')"
        type="email" formControlName="correo" placeholder="Escribe aquí" maxlength="50" autocomplete="email"
        (input)="onCorreoInput($event)" />
      @if (isInvalid('correo')) {
      <div class="home-cuenta__error">{{ errorMsg('correo') }}</div>
      }
    </div>
  </div>

  <div class="home-cuenta__row home-cuenta__row--document">
    <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalid('tipoDoc')">
      <label class="home-cuenta__label" [for]="idPrefix + '-tipo-doc'">Tipo de doc*</label>
      <select [id]="idPrefix + '-tipo-doc'" class="home-cuenta__select" [class.is-invalid]="isInvalid('tipoDoc')"
        formControlName="tipoDoc">
        <option [value]="''">Selecciona</option>
        @for (doc of documentos; track doc.idTipoDocIdentidad) {
        <option [value]="doc.idTipoDocIdentidad">{{ doc.nombre }}</option>
        }
      </select>
      @if (isInvalid('tipoDoc')) {
      <div class="home-cuenta__error">{{ errorMsg('tipoDoc') }}</div>
      }
    </div>
    <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalid('numDoc')">
      <label class="home-cuenta__label" [for]="idPrefix + '-num-doc'">Número documento*</label>
      <input [id]="idPrefix + '-num-doc'" class="home-cuenta__input" [class.is-invalid]="isInvalid('numDoc')"
        type="text" formControlName="numDoc" placeholder="Escribe aquí" maxlength="15" autocomplete="off"
        appNumeroDocumentoPorTipo [tipos]="documentos" idTipoDocControlName="tipoDoc" />
      @if (isInvalid('numDoc')) {
      <div class="home-cuenta__error">{{ errorMsg('numDoc') }}</div>
      }
    </div>
    <div class="home-cuenta__field"
      [class.home-cuenta__field--invalid]="isInvalid('confirmaDoc') || form.get('confirmaDoc')?.hasError('confirmDocMismatch')">
      <label class="home-cuenta__label" [for]="idPrefix + '-confirma-doc'">Confirma documento*</label>
      <input [id]="idPrefix + '-confirma-doc'" class="home-cuenta__input"
        [class.is-invalid]="isInvalid('confirmaDoc') || form.get('confirmaDoc')?.hasError('confirmDocMismatch')"
        type="text" formControlName="confirmaDoc" placeholder="Escribe aquí" maxlength="15" autocomplete="off"
        appNumeroDocumentoPorTipo [tipos]="documentos" idTipoDocControlName="tipoDoc" [allowPaste]="false"
        oncopy="return false" />
      @if (form.get('confirmaDoc')?.hasError('confirmDocMismatch') && (form.get('confirmaDoc')?.dirty ||
      form.get('confirmaDoc')?.touched)) {
      <div class="home-cuenta__error">Los números de documento no coinciden</div>
      } @else if (isInvalid('confirmaDoc')) {
      <div class="home-cuenta__error">{{ errorMsg('confirmaDoc') }}</div>
      }
    </div>
  </div>

  <div class="home-cuenta__row home-cuenta__row--stack-mobile">
    <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalid('password')">
      <label class="home-cuenta__label" [for]="idPrefix + '-password'">Crea tu contraseña*</label>
      <div class="home-cuenta__password-wrap">
        <input [id]="idPrefix + '-password'" class="home-cuenta__input home-cuenta__input--password"
          [class.is-invalid]="isInvalid('password')" [attr.type]="showPassword ? 'text' : 'password'"
          formControlName="password" placeholder="Escribe aquí" autocomplete="new-password" (focus)="onPasswordFocus()"
          (blur)="onPasswordBlur()" />
        <button type="button" class="home-cuenta__password-toggle" (mousedown)="$event.preventDefault()"
          (click)="togglePassword()" [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
          <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" aria-hidden="true"></i>
        </button>
      </div>
      @if (isInvalid('password')) {
      <div class="home-cuenta__error">{{ errorMsg('password') }}</div>
      } @else if (passwordFieldActive) {
      <div class="home-cuenta__hint">{{ passwordHint }}</div>
      }
    </div>
    <div class="home-cuenta__field"
      [class.home-cuenta__field--invalid]="isInvalid('confirmaPassword') || form.get('confirmaPassword')?.hasError('confirmPasswordMismatch')">
      <label class="home-cuenta__label" [for]="idPrefix + '-confirma-password'">Confirma tu contraseña*</label>
      <div class="home-cuenta__password-wrap">
        <input [id]="idPrefix + '-confirma-password'" class="home-cuenta__input home-cuenta__input--password"
          [class.is-invalid]="isInvalid('confirmaPassword') || form.get('confirmaPassword')?.hasError('confirmPasswordMismatch')"
          [attr.type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmaPassword"
          placeholder="Escribe aquí" autocomplete="new-password" />
        <button type="button" class="home-cuenta__password-toggle" (click)="toggleConfirmPassword()"
          [attr.aria-label]="showConfirmPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
          <i [class]="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" aria-hidden="true"></i>
        </button>
      </div>
      @if (form.get('confirmaPassword')?.hasError('confirmPasswordMismatch') && (form.get('confirmaPassword')?.dirty ||
      form.get('confirmaPassword')?.touched)) {
      <div class="home-cuenta__error">Las contraseñas no coinciden</div>
      } @else if (isInvalid('confirmaPassword')) {
      <div class="home-cuenta__error">{{ errorMsg('confirmaPassword') }}</div>
      }
    </div>
  </div>

  <div class="home-cuenta__row home-cuenta__row--stack-mobile">
    <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalid('contacto')">
      <label class="home-cuenta__label home-cuenta__label--single-line" [for]="idPrefix + '-contacto'">¿Cómo deseas ser
        contactado?&nbsp;*</label>
      <select [id]="idPrefix + '-contacto'" class="home-cuenta__select selectpicker"
        [class.is-invalid]="isInvalid('contacto')" formControlName="contacto" multiple data-live-search="true"
        data-size="4" data-width="100%" data-container="body" data-dropup-auto="true" data-actions-box="true"
        data-select-all-text="<i class='fas fa-plus'></i> Seleccionar"
        data-deselect-all-text="<i class='fas fa-minus'></i> Quitar todos" title="Selecciona una opción"
        (change)="selectpickerChangeContactos()">
        @for (tipo of tiposContacto; track tipo.idTipoContacto) {
        <option [value]="tipo.idTipoContacto">{{ tipo.nombre }}</option>
        }
      </select>
      @if (isInvalid('contacto')) {
      <div class="home-cuenta__error">{{ errorMsg('contacto') }}</div>
      }
    </div>
    <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalid('origen')"
      [class.home-cuenta__field--disabled-look]="!origenHabilitado">
      <label class="home-cuenta__label home-cuenta__label--single-line" [for]="idPrefix + '-origen'">¿Cómo te enteraste
        de neocrédito?&nbsp;*</label>
        <select [id]="idPrefix + '-origen'" class="home-cuenta__select selectpicker"
          [class.is-invalid]="isInvalid('origen')" formControlName="origen" data-live-search="true" data-size="6"
          data-width="100%" data-container="body" data-dropup-auto="true"
          [attr.disabled]="!origenHabilitado ? true : null"
          (change)="selectpickerChangeOrigen()">
        <option value="" disabled hidden>Selecciona una opción</option>
        @for (fuente of fuentes; track fuente.idFuenteNeocredito) {
        <option [value]="fuente.idFuenteNeocredito">{{ fuente.fuente }}</option>
        }
      </select>
      @if (isInvalid('origen')) {
      <div class="home-cuenta__error">{{ errorMsg('origen') }}</div>
      }
    </div>
  </div>

  <app-home-cuenta-form-footer [idPrefix]="idPrefix" [fieldsComplete]="form.valid"
    (submit)="onSubmit()"></app-home-cuenta-form-footer>
</form>